const teamMembersData = [
  // Add your TeamMember data here
  {
    name: "Yassine Damiri",
    mail: "yassine.damiri@epita.fr",
    role: "Developer FullStack",
    description: `Yassine Damiri, a member of the Dry Lab team, played a key role in designing our wiki. With his
extensive experience in web design, he brought both initiative and a keen sense of listening to the
project. His expertise significantly improved the functionality and aesthetics of our wiki, enhancing
communication and demonstration of the work performed.`,
    src: "https://static.igem.wiki/teams/4577/wiki/team-pictures/yassine-damiri.jpg",
    team: "Dry lab",
    oneline: "5th year engineer student in Epita",
    linkedin: "https://www.linkedin.com/in/yassine-damiri/",
    urls: ["https://github.com/Yasha-ops", "https://damiri.fr"],
  },
  {
    name: "Jacqueline Gauthier",
    role: "Team leader",
    src: "https://static.igem.wiki/teams/4577/wiki/team-pictures/jacqueline-gauthier.jpg",
    team: "Wet lab",
    oneline: "5th year engineer student in SupBiotech",
    linkedin: "https://www.linkedin.com/in/jacqueline-gauthier-8a74071ab",
    description: `Jacqueline Gauthier serves as a team leader, managing the activities of each department within the
team. Her role involves orchestrating events, overseeing the recruitment, communication and
education within our organization, and procuring essential equipment and funds for the laboratory.
She also helped the Wet lab team during the summer. Her multifaceted responsibilities exemplify
her dedication to ensuring the smooth functioning, growth and well-being of the team.`,
  },
  {
    name: "Axelle Dagorn",
    role: "Vice-team leader, Human Practices and Finance team member",
    src: "https://static.igem.wiki/teams/4577/wiki/team-pictures/axelle-dagorn.jpg",
    team: "Wet lab",
    oneline: "5th year engineer student in SupBiotech",
    linkedin: "https://www.linkedin.com/in/axelle-d-ba9a31197/",
    description: `Axelle Dagorn, serving as Vice Team Leader, is contributing for human practices and finance within
our teams. She has build strategic partnerships with businesses through her extensive networking
efforts. In addition, Axelle provided support in the laboratory during the summer. Axelle's ability to
connect our team with external collaborators has significantly enriched our Human Practices studies
and contributed to our overall success.`,
  },
  {
    name: "Pauline Rémont",
    role: "Wet lab leader, Secretary and Human Practices member",
    src: "https://static.igem.wiki/teams/4577/wiki/team-pictures/pauline-remont-2.jpg",
    team: "Wet lab",
    oneline: "5th year engineer student in SupBiotech",
    linkedin: "https://www.linkedin.com/in/pauline-r%C3%A9mont-5b46741aa/",
    description:
      "Pauline Rémont is the Head of the Wet Lab team and a member of the Human Practices team. Her role involves hands-on work in the laboratory, where she meticulously designs plasmids and oversees experiments with unwavering dedication. She goes beyond the lab, engaging in interviews with stakeholders for Human Practices to better grasp overarching issues, bridging the gap between research and real-world applications.",
  },
  {
    name: "Victor Langlois",
    role: "Treasurer, Human Practices, Finance and Dry lab team member",
    src: "https://static.igem.wiki/teams/4577/wiki/team-pictures/langlois-victor-39.jpg",
    team: "Dry lab",
    oneline: "5th year engineer student in SupBiotech",
    linkedin: "https://www.linkedin.com/in/victor-langlois-91a0a41ba/",
    description:
      "Victor Langlois, a member of the Human Practices team and contributor to Finance and Dry Lab teams, played a versatile role within our organization. Willing to help in multiple ways, he engaged with project stakeholders, secured partnerships with companies, managed our online pot, and oversaw the launch of the Dry Lab team. Additionally, he provided support in the laboratory during the summer.",
  },
  {
    name: "Basile Leroy",
    role: "Wet lab and Dry lab team member",
    src: "https://static.igem.wiki/teams/4577/wiki/team-pictures/basile-leroy.jpg",
    team: "Wet lab and Dry lab",
    oneline: "5th year engineer student in SupBiotech",
    linkedin: "https://www.linkedin.com/in/basile-leroy-bb091a1bb/",
    description:
      "Basile Leroy, as a member of both the Wet Lab and Dry Lab teams, made significant contributions to our organization. In the Wet Lab, he was involved in protocol development, execution, and results analysis. Additionally, Basile assisted in the launch of the Dry Lab team and monitored their progress.",
  },
  {
    name: "Maé Bourgeois",
    role: "Wet lab team member",
    src: "https://static.igem.wiki/teams/4577/wiki/team-pictures/mae-bourgeois.jpg",
    team: "Wet lab",
    oneline: "3rd year Bachelor degree student in SupBiotech",
    linkedin: "https://www.linkedin.com/in/ma%C3%A9-bourgeois-257680234/",
    description:
      "Maé Bourgeois is a member of the Wet Lab team. She participated in the plasmid design, protocol development, and played a pivotal role in organizing, conducting, and analyzing experiments. Maé's exceptional organizational skills, experience in molecular biology, and hands-on approach were instrumental in the successful execution of our laboratory work.",
  },
  {
    name: "Mathis Ribeiro",
    role: "Wet lab team member",
    src: "https://static.igem.wiki/teams/4577/wiki/team-pictures/mathis-ribeiro.jpg",
    team: "Wet lab",
    oneline: "3rd year Bachelor degree student in SupBiotech",
    linkedin: "https://www.linkedin.com/in/mathis-ribeiro-a5363a234/",
    description:
      "Mathis Ribeiro, as a member of the Wet Lab team, made significant contributions to our organization. His primary responsibilities included protocol refinement, and his creative approach added an innovative dimension to our experiments. Mathis was actively involved in experiment execution and meticulous result analysis.",
  },
  {
    name: "Ethan Lottier",
    role: "Wet lab team member",
    src: "https://static.igem.wiki/teams/4577/wiki/team-pictures/ethan-lottier.jpg",
    team: "Wet lab",
    oneline: "3rd year Bachelor degree student in SupBiotech",
    linkedin: "https://www.linkedin.com/in/ethan-lottier-292638234/",
    description:
      "Ethan Lottier is a valued member of the Wet Lab team. His role primarily involved protocol refinement, and his meticulous approach to experimentation and result analysis ensured the highest level of accuracy and quality in our research efforts. His dedication and expertise significantly contributed to the success of the laboratory research.",
  },
  {
    name: "Baptiste Collin",
    role: "Dry lab team member",
    src: "https://static.igem.wiki/teams/4577/wiki/team-pictures/baptiste-collin.jpg",
    team: "Dry lab",
    oneline: "3rd year engineer student in Epita",
    linkedin: "https://www.linkedin.com/in/baptiste-c-b328b8240/",
    description:
      "Baptiste Collin, a member of the Dry Lab team, brings a wealth of experience from his participation in last year's iGEM IONIS project. His commitment to our team is evident through his willingness to assist fellow members. Baptiste is taking the lead in developing a mobile game centered around synthetic biology.",
  },
  {
    name: "Thomas Sanchez",
    role: "Dry lab team member",
    src: "https://static.igem.wiki/teams/4577/wiki/team-pictures/thomas-sanchez.jpeg",
    team: "Dry lab",
    oneline: "5th year engineer student in Epita",
    linkedin: "https://www.linkedin.com/in/thomas-sanchez-25b4a4231/",
    description:
      "Thomas Sanchez, a valued member of the Dry Lab team, assumes responsibility for computer modeling. His notable ability to quickly grasp complex concepts and his genuine interest in various aspects of the project make him a valuable asset to our team. Thomas's dedication to computational modeling is instrumental in our project's success.",
  },
  {
    name: "Alexia Baudrand",
    role: "Dry lab team member",
    src: "https://static.igem.wiki/teams/4577/wiki/team-pictures/alexia-baudrand.jpg",
    team: "Dry lab",
    oneline: "5th year engineer student in ESME",
    linkedin: "https://www.linkedin.com/in/alexia-baudrand-55483420b/",
    description:
      "Alexia Baudrand, a member of the Dry Lab team, spearheads the creation of our prototype. Her exceptional skills in manual work, proficiency in wiring, and expertise in 3D printing are invaluable to our project's development. Alexia's proactive nature and unwavering positivity serve as a driving force behind our team's motivation and progress.",
  },
  {
    name: "Yasmina Kourrich",
    role: "Dry lab team member",
    src: "https://static.igem.wiki/teams/4577/wiki/team-pictures/yasmina-kourrich.jpg",
    team: "Dry lab",
    oneline: "5th year engineer student in ESME",
    linkedin: "https://www.linkedin.com/in/yasmina-kourrich-7b0412268/",
    description:
      "Yasmina Kourrich, a valuable member of the Dry Lab team, takes the lead in designing and selecting materials for our system. She also conducts cost estimations for the final system. Yasmina's ability to quickly grasp new concepts and her meticulous approach to system design and budgeting make her an asset to our project.",
  },
  {
    name: "Thomas Lemonnier, PhD",
    role: "PI",
    src: "https://static.igem.wiki/teams/4577/wiki/team-pictures/thomas-lemonnier.jpg",
    team: "Instructor",
    oneline: "Researcher at the Cell techs CEA/SupBiotech laboratory",
    description:
      "Thomas is a researcher at the Cell techs CEA/SupBiotech laboratory where he studies neurodegenerative disease models using induced pluripotent cells. He was of great support, accompanying us throughout our project, promptly addressing our inquiries and mentoring us.",
  },
  {
    name: "Ambe Leleu, PhD",
    role: "Instructor",
    src: "https://static.igem.wiki/teams/4577/wiki/team-pictures/ambre-leleu.jpg",
    team: "Instructor",
    oneline: "PhD student at the Cell techs CEA/SupBiotech laboratory",
    description:
      "Ambre is a PhD student at the Cell techs CEA/SupBiotech laboratory and former iGEM team member. She studies neurodegenerative disease models using induced pluripotent cells and teaches at SupBiotech. Thanks to her former iGEM experience, she helped us a lot by answering our questions, giving advice, and mentoring us all through the competition.",
  },
];

export default teamMembersData;
